var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"praise_mian",on:{"click":function($event){_vm.praise()}}},[_c('i',{class:_vm.praised ? 'sh-icon-praised praised' : 'sh-icon-praise'}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.total))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b029394","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/view/interact/cmps/praise/src/praise.vue
// module id = null
// module chunks = 